export const VIEW_TYPES = {
    tableV2: {
        label: 'Table',
        icon: 'Sheet',
        display: 'tableV2',
    },
    cardV2: {
        label: 'Cards',
        icon: 'LayoutGrid',
        display: 'cardV2',
    },
    boardV2: {
        label: 'Board',
        icon: 'KanbanSquare',
        display: 'boardV2',
    },
    thread: {
        label: 'Conversation',
        icon: 'MessageSquareText',
        display: 'thread',
    },
    single_record: {
        label: 'Single record',
        icon: 'NotepadText',
        display: 'single_record',
    },
} as const

export const CREATABLE_VIEW_TYPES = {
    tableV2: VIEW_TYPES.tableV2,
    cardV2: VIEW_TYPES.cardV2,
    boardV2: VIEW_TYPES.boardV2,
    thread: VIEW_TYPES.thread,
    single_record: VIEW_TYPES.single_record,
}
